enum VerificationFlagStatus {
  INVALID_FLAG_STATUS
  FLAG_NONE
  FLAG_CRITICAL
  FLAG_WARNING
  FLAG_CLEARED
}

enum VerificationScope {
  INVALID_VERIFICATION_SCOPE
  VERIFICATION_SCOPE_CRM
  VERIFICATION_SCOPE_CP
}

type VerificationEntity {
  id: ID
  type: String
}

type VerificationCollection {
  collection_id: ID!
  name: String
  passed: Boolean
  outstanding_optional: Boolean
  required_for_future_transition: Boolean
  required_for_next_transition: Boolean
  version: String
  verifications: [Verification!]
}

type Verification {
  verification_id: ID!
  name: String
  passed: Boolean
  explanation: String
  case_id: ID
  client_id: ID
  mortgage_id: ID
  product_id: ID
  property_id: ID
  failed_fields: [String!]
  flag: VerificationFlagStatus
  iterable_id: String
  optional: Boolean
  entities: [VerificationEntity]
  scopes: [VerificationScope]
  result_justification: [String!]
  auto_satisfy: [AutoSatisfy]
}
